import React, { useMemo } from "react";
import CircularProgressWithLabel from "../CircularProgressWithLabel";

import "./modal-with-loading.styles.css";

const ModalWithLoading = ({
  headerText = "Atualização de dados",
  title = "Encerrando atendimentos",
  text = "Estamos encerrando os atendimentos. Aguarde até a conclusão para continuar.",
  qtdCompleteds = 0,
  qtdTotal = 100,
}) => {
  const progress = useMemo(() => {
    if (qtdTotal === 0) {
      return 0;
    }
    return parseInt((qtdCompleteds / qtdTotal) * 100);
  }, [qtdCompleteds, qtdTotal]);
  return (
    <div
      className="modal micromodal-slide modal-with-loading"
      id="modal__modal-with-loading"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container modal-with-loading__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__modal-with-loading"
        >
          <header>{headerText}</header>
          <div className="modal-with-loading__container__qtd-content">
            <div>
              <CircularProgressWithLabel value={progress} />
            </div>
            <span className="modal-with-loading__container__qtd-content__qtds">{`${qtdCompleteds} de ${qtdTotal}`}</span>
          </div>
          <div className="modal-with-loading__container__text-container">
            <h1 className="modal-with-loading__container__text-container__title">
              {title}
            </h1>
            <p className="modal-with-loading__container__text-container__text">
              {text}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalWithLoading;
